import { render } from "./HeaderCustomer.vue?vue&type=template&id=5dd57088&scoped=true&ts=true&lang=pug"
import script from "./HeaderCustomer.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderCustomer.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderCustomer.vue?vue&type=style&index=0&id=5dd57088&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd57088"]])

export default __exports__